import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { wsAddLayer } from "../../../../_actions/webSocketAction";
import { ImageItem } from "../../../common/statelessView";
import { REPLACE_META } from "../../../../_actions/types";
import {
  fetchData,
  search,
  closeSlider,
} from "../../../../_actions/sidebarSliderActions";
import { prepareVideoPayload } from "../../../../_utils/common";
import TldrMediaTrimmingModal from "../../../common/TldrMediaTrimmingModal";
import {
  DEFAULT_ARTBOARD_DURATION,
  StoryTypes,
} from "../../../../_utils/constants";
import { STILL_EFFECT } from "../../advanced/animations/defaultLayerAnimations";
import SuperList from "./SuperList";
import { withTranslation } from "react-i18next";

class VideoList extends Component {
  constructor(props) {
    super(props);
    this.addLayerCallback = this.addLayerCallback.bind(this);

    this.state = {
      showTrimmingModal: false,
      videoData: null,
      maxTrimPercentage: null,
    };
  }

  render() {
    const { sidebarSlider, story, t } = this.props;
    const { showTrimmingModal, videoData, maxTrimPercentage } = this.state;
    const { videoSource, loaded, payload, hasMore } = sidebarSlider;

    const childElements = payload.map((video) => {
      const payload = prepareVideoPayload(
        videoSource,
        video,
        story.contentSize,
        this.props.editor.activePage.id
      );

      return (
        <div
          key={video.id}
          className="item"
          onClick={() => this.addLayerCallback(payload)}
          data-grid-groupkey={video.groupKey}
        >
          <ImageItem
            data={payload}
            key={video.id}
            url={payload.content.url}
            alt={video.tags}
            width={200}
            height={110}
            source={videoSource}
            showOverlayInfo={true}
            isUsedInSwiper={false}
            video_src={payload.payload.src}
          />
        </div>
      );
    });
    return (
      <>
        <SuperList
          list="video-gallery"
          loaded={loaded}
          searchPlaceholder={t("search.search_videos")}
          notFound={t("search.no_videos")}
          errorsView={null}
          hasMore={hasMore}
          loadPage={this.loadPage}
          showRecents
          onClickRecent={this.addLayerCallback}
        >
          {childElements}
        </SuperList>

        {videoData && showTrimmingModal && (
          <TldrMediaTrimmingModal
            show={showTrimmingModal}
            onHide={() => {
              this.setState({
                ...this.state,
                showTrimmingModal: false,
                videoData: null,
                maxTrimPercentage: null,
              });
            }}
            onSubmit={this.onSubmitTrim}
            data={videoData}
            mediaType={"Video"}
            maxTrimPercentage={maxTrimPercentage}
            defaultTrimPercentage={maxTrimPercentage}
          />
        )}
      </>
    );
  }

  loadPage = (groupKey) => {
    // There is no searchText then fetch general images and add into InfiniteGrid
    if (!this.props.searchText) {
      this.props.fetchData(this.props.sidebarSlider.videoSource, {
        ...this.props,
        groupKey,
      });
      return;
    }
    this.props.search(
      this.props.sidebarSlider.videoSource,
      this.props.searchText,
      { ...this.props, groupKey }
    );
  };

  getPageDuration = () => {
    const {
      editor: { activePage: { id } = {} },
      pages,
    } = this.props;
    const page = pages[id];
    if (page) {
      return page?.payload?.animation?.duration ?? DEFAULT_ARTBOARD_DURATION;
    }
    return DEFAULT_ARTBOARD_DURATION;
  };

  addLayer = (data) => {
    var updatedVideoPayload = data ? data : this.state.videoData;
    this.props.wsAddLayer(this.props.editor.activePage.id, updatedVideoPayload);
  };

  onSubmitTrim = ({ startTime, endTime, muted }) => {
    const { videoData } = this.state;
    const updatedVideoData = {
      ...videoData,
      payload: {
        ...videoData.payload,
        startTime: startTime,
        endTime: endTime,
        muted: muted,
      },
    };
    this.setState(
      {
        showTrimmingModal: false,
        videoData: null,
      },
      () => this.addLayer(updatedVideoData)
    );
  };

  updateLayer = (data) => {
    const { canvasRef } = this.props;

    let target = canvasRef.handler.findById(this.props.editor.activeElement.id);

    if (!target) {
      return;
    }

    canvasRef.handler.elementHandler.setById(
      this.props.editor.activeElement.id,
      data.payload.src
    );

    canvasRef.handler.elementHandler.setCoverById(
      this.props.editor.activeElement.id,
      data.content.url
    );

    if (data?.content?.source_id) {
      target.userProperty = {
        ...target.userProperty,
        source_id: data.content.source_id,
      };
    }
    canvasRef.handler.canvas.fire("object:modified", {
      target,
      message: { content: data.content },
    });
  };

  addLayerCallback = (data) => {
    const { story: { payload: { story_type } = {} } = {} } = this.props;
    const { action } = this.props.sidebarSlider;
    if (action === REPLACE_META) {
      this.updateLayer(data);
    } else {
      if (story_type === StoryTypes.ANIMATED) {
        const pageDuration = this.getPageDuration();
        const videoDuration =
          data.payload?.duration ?? data.content.meta?.duration;
        if (!data.payload?.animation) {
          data.payload.animation = [
            {
              ...STILL_EFFECT,
              start_time: 0,
              trans_duration: Math.min(pageDuration, videoDuration) * 1000,
              end_time: Math.min(pageDuration, videoDuration) * 1000,
            },
          ];
        }
        // if (pageDuration && videoDuration && pageDuration < videoDuration) {
        //   // const maxTrimPercentage = (pageDuration / videoDuration) * 100;
        //   // this.setState({
        //   //   showTrimmingModal: true,
        //   //   videoData: data,
        //   //   maxTrimPercentage: maxTrimPercentage,
        //   // });
        //   this.addLayer(data);
        // } else {
        //   this.addLayer(data);
        // }
        // } else {
        //   this.addLayer(data);
      }
      this.addLayer(data);
    }
    if (this.props.isMobileView) {
      this.props.closeSlider();
    }
  };
}

VideoList.propTypes = {
  editor: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  sidebarSlider: PropTypes.object.isRequired,
  panelType: PropTypes.string.isRequired,
  searchText: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  sidebarSlider: state.sidebarSlider,
  errors: state.errors,
  editor: state.editor,
  pages: state.pagestore?.pages,
  panelType: state.sidebarSlider.sliderPanelType,
  searchText: state.sidebarSlider.searchText,
  story: state.story,
  page: state.sidebarSlider.page,
  auth: state.auth,
  isMobileView: state.app.isMobileView,
});

const mapDispatchToProps = (dispatch) => ({
  wsAddLayer: (activePageId, payload) =>
    dispatch(wsAddLayer(activePageId, payload)),
  fetchData: (videoSource, props) => dispatch(fetchData(videoSource, props)),
  search: (videoSource, searchTerm, props) =>
    dispatch(search(videoSource, searchTerm, props)),
  closeSlider: () => dispatch(closeSlider()),
});

export default withTranslation(["common"])(
  connect(mapStateToProps, mapDispatchToProps)(VideoList)
);
